import { ResourceGroupAccess } from "@/components/share/ResourceGroupAccess";
import { ResourceType } from "gitpod-next-api/gitpod/v1/event_pb";
import { type FC } from "react";

type RunnerGroupAccessProps = {
    runnerId: string;
    maxVisible?: number;
    className?: string;
};

export const RunnerGroupAccess: FC<RunnerGroupAccessProps> = ({ runnerId, maxVisible, className }) => {
    return (
        <ResourceGroupAccess
            resourceType={ResourceType.RUNNER}
            resourceId={runnerId}
            maxVisible={maxVisible}
            className={className}
            trackingPrefix="runner"
        />
    );
};
